var jade = require("C:\\Dev\\repos\\player\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var jade_debug = [ new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ) ];
try {
var buf = [];
var jade_mixins = {};
var jade_interp;
var self = locals || {};
jade_debug.unshift(new jade.DebugItem( 0, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
jade_debug.unshift(new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"video-wrapper\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 2, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<video width=\"640\" height=\"360\" style=\"width:100%; height:100%\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 3, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<source type=\"video/mp4\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 4, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<track/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 5, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("Your browser does not support the video tag.");
jade_debug.shift();
jade_debug.shift();
buf.push("</video>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 6, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"controls\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 7, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"progress-bar\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 8, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"bar\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 9, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"progress video-progress\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 10, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<hr/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 11, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"time-progress\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 12, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<span class=\"now\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 13, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<span>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 13, jade_debug[0].filename ));
buf.push("&nbsp / &nbsp");
jade_debug.shift();
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 14, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<span class=\"total\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 16, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"volume\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 17, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Volume down\" class=\"vol-down\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 18, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 19, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M138,199h-10\t\t\t\t\t\t\t\t  l-40-40H57V97h31l40-40h10V199z M209,108.4L190.4,128l18.6,19.6V158h-9.7l-18.8-19.8L161.7,158H152v-10.4l18.6-19.6L152,108.4V98\t\t\t\t\t\t\t\t  h9.7l18.8,19.8L199.3,98h9.7V108.4z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 23, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Volume up\" class=\"vol-up\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 24, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 25, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M138,199h-10\t\t\t\t\t\t\t  l-40-40H57V97h31l40-40h10V199z M160.3,158.5c-2.4,2.2-4.9,4.3-9.3-0.6c-4.3-4.9-2-7.1,0.6-9.3c4.1-3.7,6.7-9.3,6.7-15\t\t\t\t\t\t\t  c0-5.7-2.8-11.4-7.3-15.2c-2.6-2.2-4.9-4.1-0.8-9.3c4.3-5.1,6.9-3,9.5-0.8c7.3,6.1,11.8,15.8,11.8,25.2\t\t\t\t\t\t\t  C171.5,143.1,167.4,152.4,160.3,158.5z M179,177.6c-2.4,2.2-4.9,4.5-9.3-0.4c-4.3-5.1-2-7.3,0.6-9.5c9.5-8.5,15.2-21.1,15.2-33.9\t\t\t\t\t\t\t  c0-13.2-6.3-26-16.4-34.5c-2.6-2.2-5.1-4.3-0.8-9.3c4.3-5.1,6.9-3,9.3-0.8c13,10.8,21.1,27.6,21.1,44.5\t\t\t\t\t\t\t  C198.7,150.4,191.4,166.8,179,177.6z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 33, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"vol-bar\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 34, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"vol-level\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 37, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Full screen\" class=\"full-screen\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 38, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 39, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M110,192H63\t\t\t\t\tv-47l13.5,18.5L106,134l15,15l-29.5,29.5L110,192z M106,122L76.5,92.5L63,111V64h47L91.5,77.5l30,30L106,122z M193,192h-47\t\t\t\t\tl18.5-13.5L135,149l15-15l29.5,29.5L193,145V192z M193,111l-13.5-18.5L150,122l-15-15l29.5-29.5L146,64h47V111z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 43, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Black background\" class=\"black-bg\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 44, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256;\" xml:space=\"preserve\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 45, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M128,96c-17.6,0-32,14.4-32,32s14.4,32,32,32c17.6,0,32-14.4,32-32S145.6,96,128,96z M128,145c-9.4,0-16.9-7.6-16.9-17\t\t\t\t\tc0-9.4,7.6-17,16.9-17s16.9,7.6,16.9,17C144.9,137.4,137.4,145,128,145z M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178\t\t\t\t\tc6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M128,179c-42.1,0-76-51-76-51s32.9-51,75-51h1c42.1,0,76,51,76,51\t\t\t\t\tS170.1,179,128,179z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 52, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Toggle subtitle display\" class=\"cc\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 53, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 54, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M100,149.8\t\t\t\t\tc5.8,0,10.3-1,13.9-2.4l2.9,18c-4.3,1.9-12.5,3.5-21.8,3.5c-25.3,0-41.5-15.4-41.5-40.1c0-22.9,15.7-41.7,44.9-41.7\t\t\t\t\tc6.4,0,13.5,1.1,18.6,3l-3.8,18.1c-2.9-1.3-7.2-2.4-13.6-2.4c-12.8,0-21.2,9.1-21,22C78.5,142.3,88.2,149.8,100,149.8z M185.5,149.8\t\t\t\t\tc5.8,0,10.3-1,13.9-2.4l2.9,18c-4.3,1.9-12.5,3.5-21.8,3.5c-25.3,0-41.5-15.4-41.5-40.1c0-22.9,15.7-41.7,44.9-41.7\t\t\t\t\tc6.4,0,13.5,1.1,18.6,3l-3.8,18.1c-2.9-1.3-7.2-2.4-13.6-2.4c-12.8,0-21.2,9.1-21,22C164,142.3,173.6,149.8,185.5,149.8z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 60, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"controls-wrapper\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 64, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Jump 10 Frames\" class=\"fb10f\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 65, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 66, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M221,229H35c-4.4,0-8-3.6-8-8V35c0-4.4,3.6-8,8-8h186c4.4,0,8,3.6,8,8v186C229,225.4,225.4,229,221,229z M175,77l-83,45V76\t\t\t\t\tH70v101h22v-43l83,45V77z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 69, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Jump 1 Frame\" class=\"fb1f\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 70, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 71, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M221,229H35c-4.4,0-8-3.6-8-8V35c0-4.4,3.6-8,8-8h186c4.4,0,8,3.6,8,8v186C229,225.4,225.4,229,221,229z M171,77l-94,51\t\t\t\t\tl94,51V77z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 76, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Decrease playback speed\" class=\"speed-down\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 77, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 78, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M221,229H35c-4.4,0-8-3.6-8-8V35c0-4.4,3.6-8,8-8h186c4.4,0,8,3.6,8,8v186C229,225.4,225.4,229,221,229z M194,85l-64,38.4\t\t\t\t\tV85l-72,43l72,43v-38.4l64,38.4V85z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 81, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Play\" class=\"play\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 82, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 83, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M240,128L240,128c0,61.9-52.4,112-114.4,112l0,0C63.7,240,16,189.9,16,128v0C16,66.1,66.1,16,128,16h0\t\t\t\t\tC189.9,16,240,66.1,240,128z M94,185l97-56L94,73V185z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 86, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Pause\" class=\"pause\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 87, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 88, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M128,16L128,16C66.1,16,16,66.1,16,128v0c0,61.9,47.7,112,109.6,112S240,189.9,240,128v0C240,66.1,189.9,16,128,16z\t\t\t\t\tM115,186H86V72h29V186z M170,186h-29V72h29V186z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 91, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Increase playback speed\" class=\"speed-up\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 92, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 93, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M35,27h186c4.4,0,8,3.6,8,8v186c0,4.4-3.6,8-8,8H35c-4.4,0-8-3.6-8-8V35C27,30.6,30.6,27,35,27z M62,171l64-38.4V171l72-43\t\t\t\t\tl-72-43v38.4L62,85V171z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 96, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Jump 1 Frame\" class=\"ff1f\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 97, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 98, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M35,27h186c4.4,0,8,3.6,8,8v186c0,4.4-3.6,8-8,8H35c-4.4,0-8-3.6-8-8V35C27,30.6,30.6,27,35,27z M85,179l94-51L85,77V179z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 100, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Jump 10 Frames\" class=\"ff10f\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 101, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 102, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M35,27h186c4.4,0,8,3.6,8,8v186c0,4.4-3.6,8-8,8H35c-4.4,0-8-3.6-8-8V35C27,30.6,30.6,27,35,27z M81,179l83-45v46h22V79h-22\t\t\t\t\t\tv43L81,77V179z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 105, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"speed\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 105, jade_debug[0].filename ));
buf.push("1x");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 108, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div title=\"Stop\" class=\"stop\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 109, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 110, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<path d=\"M221,229H35c-4.4,0-8-3.6-8-8V35c0-4.4,3.6-8,8-8h186c4.4,0,8,3.6,8,8v186C229,225.4,225.4,229,221,229z M172,172V84H84v88H172z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 114, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div class=\"subtitle-display\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 115, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<table>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 116, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<tr>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 117, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<td>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 118, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<div>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 119, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<p contenteditable=\"false\" class=\"row1-subtitle\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 120, "C:\\Dev\\repos\\player\\app\\templates\\player.jade" ));
buf.push("<p contenteditable=\"false\" class=\"row2-subtitle\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</td>");
jade_debug.shift();
jade_debug.shift();
buf.push("</tr>");
jade_debug.shift();
jade_debug.shift();
buf.push("</table>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();;return buf.join("");
} catch (err) {
  jade.rethrow(err, jade_debug[0].filename, jade_debug[0].lineno, ".video-wrapper\r\n\tvideo(width='640',height=\"360\" style=\"width:100%; height:100%\")\r\n\t\tsource(type=\"video/mp4\")\r\n\t\ttrack\r\n\t\t| Your browser does not support the video tag.\r\n\t.controls\r\n\t\t.progress-bar\r\n\t\t\t\t\t.bar\r\n\t\t\t\t\t\t.progress.video-progress\r\n\t\t\t\thr\r\n\t\t.time-progress\r\n\t\t\t\tspan.now\r\n\t\t\t\tspan &nbsp / &nbsp\r\n\t\t\t\tspan.total\r\n\t\t\t\r\n\t\t\t.volume\r\n\t\t\t\t.vol-down(title=\"Volume down\")\r\n\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\tpath(d='M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M138,199h-10\\\r\n\t\t\t\t\t\t\t\t  l-40-40H57V97h31l40-40h10V199z M209,108.4L190.4,128l18.6,19.6V158h-9.7l-18.8-19.8L161.7,158H152v-10.4l18.6-19.6L152,108.4V98\\\r\n\t\t\t\t\t\t\t\t  h9.7l18.8,19.8L199.3,98h9.7V108.4z')\r\n\r\n\t\t\t\t.vol-up(title=\"Volume up\")\r\n\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\tpath(d='M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M138,199h-10\\\r\n\t\t\t\t\t\t\t  l-40-40H57V97h31l40-40h10V199z M160.3,158.5c-2.4,2.2-4.9,4.3-9.3-0.6c-4.3-4.9-2-7.1,0.6-9.3c4.1-3.7,6.7-9.3,6.7-15\\\r\n\t\t\t\t\t\t\t  c0-5.7-2.8-11.4-7.3-15.2c-2.6-2.2-4.9-4.1-0.8-9.3c4.3-5.1,6.9-3,9.5-0.8c7.3,6.1,11.8,15.8,11.8,25.2\\\r\n\t\t\t\t\t\t\t  C171.5,143.1,167.4,152.4,160.3,158.5z M179,177.6c-2.4,2.2-4.9,4.5-9.3-0.4c-4.3-5.1-2-7.3,0.6-9.5c9.5-8.5,15.2-21.1,15.2-33.9\\\r\n\t\t\t\t\t\t\t  c0-13.2-6.3-26-16.4-34.5c-2.6-2.2-5.1-4.3-0.8-9.3c4.3-5.1,6.9-3,9.3-0.8c13,10.8,21.1,27.6,21.1,44.5\\\r\n\t\t\t\t\t\t\t  C198.7,150.4,191.4,166.8,179,177.6z')\r\n\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t.vol-bar\r\n\t\t\t\t\t.vol-level\r\n\r\n\t\t\t\r\n\t\t\t.full-screen(title=\"Full screen\")\r\n\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\tpath(d='M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M110,192H63\\\r\n\t\t\t\t\tv-47l13.5,18.5L106,134l15,15l-29.5,29.5L110,192z M106,122L76.5,92.5L63,111V64h47L91.5,77.5l30,30L106,122z M193,192h-47\\\r\n\t\t\t\t\tl18.5-13.5L135,149l15-15l29.5,29.5L193,145V192z M193,111l-13.5-18.5L150,122l-15-15l29.5-29.5L146,64h47V111z')\r\n\r\n\t\t\t.black-bg(title=\"Black background\")\r\n\t\t\t\tsvg(xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', x='0px', y='0px', viewbox='0 0 256 256', style='enable-background:new 0 0 256 256;', xml:space='preserve')\r\n\t\t\t\t\tpath(d='M128,96c-17.6,0-32,14.4-32,32s14.4,32,32,32c17.6,0,32-14.4,32-32S145.6,96,128,96z M128,145c-9.4,0-16.9-7.6-16.9-17\\\r\n\t\t\t\t\tc0-9.4,7.6-17,16.9-17s16.9,7.6,16.9,17C144.9,137.4,137.4,145,128,145z M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178\\\r\n\t\t\t\t\tc6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M128,179c-42.1,0-76-51-76-51s32.9-51,75-51h1c42.1,0,76,51,76,51\\\r\n\t\t\t\t\tS170.1,179,128,179z')\r\n\r\n\r\n\r\n\t\t\t.cc(title=\"Toggle subtitle display\")\r\n\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\tpath(d='M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M100,149.8\\\r\n\t\t\t\t\tc5.8,0,10.3-1,13.9-2.4l2.9,18c-4.3,1.9-12.5,3.5-21.8,3.5c-25.3,0-41.5-15.4-41.5-40.1c0-22.9,15.7-41.7,44.9-41.7\\\r\n\t\t\t\t\tc6.4,0,13.5,1.1,18.6,3l-3.8,18.1c-2.9-1.3-7.2-2.4-13.6-2.4c-12.8,0-21.2,9.1-21,22C78.5,142.3,88.2,149.8,100,149.8z M185.5,149.8\\\r\n\t\t\t\t\tc5.8,0,10.3-1,13.9-2.4l2.9,18c-4.3,1.9-12.5,3.5-21.8,3.5c-25.3,0-41.5-15.4-41.5-40.1c0-22.9,15.7-41.7,44.9-41.7\\\r\n\t\t\t\t\tc6.4,0,13.5,1.1,18.6,3l-3.8,18.1c-2.9-1.3-7.2-2.4-13.6-2.4c-12.8,0-21.2,9.1-21,22C164,142.3,173.6,149.8,185.5,149.8z')\r\n\t\t\t\t\t\r\n\t\t.controls-wrapper\r\n\t\t\t\r\n\t\t\t\r\n\r\n\t\t\t.fb10f(title=\"Jump 10 Frames\")\r\n\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\tpath(d='M221,229H35c-4.4,0-8-3.6-8-8V35c0-4.4,3.6-8,8-8h186c4.4,0,8,3.6,8,8v186C229,225.4,225.4,229,221,229z M175,77l-83,45V76\\\r\n\t\t\t\t\tH70v101h22v-43l83,45V77z')\r\n\r\n\t\t\t.fb1f(title=\"Jump 1 Frame\")\r\n\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\tpath(d='M221,229H35c-4.4,0-8-3.6-8-8V35c0-4.4,3.6-8,8-8h186c4.4,0,8,3.6,8,8v186C229,225.4,225.4,229,221,229z M171,77l-94,51\\\r\n\t\t\t\t\tl94,51V77z')\r\n\r\n\t\t\t\t\r\n\r\n\t\t\t.speed-down(title=\"Decrease playback speed\")\r\n\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\tpath(d='M221,229H35c-4.4,0-8-3.6-8-8V35c0-4.4,3.6-8,8-8h186c4.4,0,8,3.6,8,8v186C229,225.4,225.4,229,221,229z M194,85l-64,38.4\\\r\n\t\t\t\t\tV85l-72,43l72,43v-38.4l64,38.4V85z')\r\n\r\n\t\t\t.play(title=\"Play\")\r\n\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\tpath(d='M240,128L240,128c0,61.9-52.4,112-114.4,112l0,0C63.7,240,16,189.9,16,128v0C16,66.1,66.1,16,128,16h0\\\r\n\t\t\t\t\tC189.9,16,240,66.1,240,128z M94,185l97-56L94,73V185z')\r\n\r\n\t\t\t.pause(title=\"Pause\")\r\n\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\tpath(d='M128,16L128,16C66.1,16,16,66.1,16,128v0c0,61.9,47.7,112,109.6,112S240,189.9,240,128v0C240,66.1,189.9,16,128,16z\\\r\n\t\t\t\t\tM115,186H86V72h29V186z M170,186h-29V72h29V186z')\r\n\r\n\t\t\t.speed-up(title=\"Increase playback speed\")\r\n\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\tpath(d='M35,27h186c4.4,0,8,3.6,8,8v186c0,4.4-3.6,8-8,8H35c-4.4,0-8-3.6-8-8V35C27,30.6,30.6,27,35,27z M62,171l64-38.4V171l72-43\\\r\n\t\t\t\t\tl-72-43v38.4L62,85V171z')\r\n\r\n\t\t\t.ff1f(title=\"Jump 1 Frame\")\r\n\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\tpath(d='M35,27h186c4.4,0,8,3.6,8,8v186c0,4.4-3.6,8-8,8H35c-4.4,0-8-3.6-8-8V35C27,30.6,30.6,27,35,27z M85,179l94-51L85,77V179z')\r\n\r\n\t\t\t.ff10f(title=\"Jump 10 Frames\")\r\n\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\tpath(d='M35,27h186c4.4,0,8,3.6,8,8v186c0,4.4-3.6,8-8,8H35c-4.4,0-8-3.6-8-8V35C27,30.6,30.6,27,35,27z M81,179l83-45v46h22V79h-22\\\r\n\t\t\t\t\t\tv43L81,77V179z')\r\n\r\n\t\t\t.speed 1x\r\n\t\t\t\t\r\n\r\n\t\t\t.stop(title=\"Stop\")\r\n\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\tpath(d='M221,229H35c-4.4,0-8-3.6-8-8V35c0-4.4,3.6-8,8-8h186c4.4,0,8,3.6,8,8v186C229,225.4,225.4,229,221,229z M172,172V84H84v88\\H172z')\r\n\r\n\t\t\r\n\r\n\t.subtitle-display\r\n\t\ttable\r\n\t\t\ttr\r\n\t\t\t\ttd\r\n\t\t\t\t\tdiv\r\n\t\t\t\t\t\tp.row1-subtitle(contenteditable=\"false\")\r\n\t\t\t\t\t\tp.row2-subtitle(contenteditable=\"false\")");
}
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/player.jade
// module id = 419
// module chunks = 0